<template>
  <div>
    <form class="mt-4">
      <div class="row">
        <div class="col">
          <label class="form-label" style="text-transform: capitalize;"
            >Search title:</label
          >
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <input type="text" class="form-control mb-2" v-model="newTitle" />
        </div>

        <div class="col-md-12 col-lg-2">
          <button
            type="button"
            class="btn btn-primary mb-2"
            @click="saveSearch"
          >
            Save search
          </button>
        </div>
      </div>
    </form>
    <div class="mt-3 text-center">
      <h6 style="text-transform: capitalize;">
        Search results ({{ allCustomerOrders.totalRecords || 0 }} records)
      </h6>

      <span v-if="!allCustomerOrders.Result || allCustomerOrders.message"
        >Showing 0 to 0 of 0 entries</span
      >
      <span v-else
        >Showing {{ (currentPage - 1) * allCustomerOrders.pageSize + 1 }} to
        {{
          (currentPage - 1) * allCustomerOrders.pageSize +
            allCustomerOrders.selectedRecordCount
        }}
        of {{ allCustomerOrders.totalRecords }} entries</span
      >
    </div>

    <div
      :class="[loading ? 'table-active' : '']"
      v-for="order in allCustomerOrders.Result"
      :key="order.id"
    >
      <table class="table table-bordered border-light table-sm mt-3">
        <thead>
          <tr>
            <th colspan="2" width="60%">
              <span>Order Id: {{ order.userorderid }}</span> -
              <span>Item Order Num: {{ order.ordernumber }}</span>
              <span v-if="order.bestBuyOrderId"> - BBY Order Id: {{ order.bestBuyOrderId }}</span>
              -
              <span
                style="color: #1890ff; cursor: pointer"
                @click="orderNotes(order)"
                ><span>[Notes]</span></span
              >
            </th>
            <th colspan="2" width="40%">
              <span class="icon-span">
                <router-link
                  :to="{
                    name: 'OrderDetails',
                    query: {
                      order_id: order.orderid,
                      order_number: order.ordernumber,
                    },
                  }"
                  ><font-awesome-icon class="icon-list" icon="edit"
                /></router-link>
                -
                <router-link
                  :to="{
                    name: 'DivvyAdminUsersEditUser',
                    params: { id: order.userid },
                  }"
                  ><font-awesome-icon class="icon-list" icon="user"
                /></router-link>
                -
                <b-link @click="orderNotes(order)"
                  ><font-awesome-icon class="icon-list" icon="envelope"
                /></b-link>
                -
                <router-link
                  :to="{
                    name: 'DivvyAdminUsersReportUser',
                    params: { id: order.userid },
                  }"
                  ><font-awesome-icon class="icon-list" icon="file-alt"
                /></router-link>
                - </span
              ><router-link
                :to="{
                  name: 'faxComponent',
                  query: { orderId: order.ordernumber },
                }"
                target="_blank"
                ><span>[Fax]</span></router-link
              >
            </th>
          </tr>
        </thead>
        <tbody v-if="loading === true">
          <div>
            <div class="centered">
              <a-spin />
            </div>
          </div>
        </tbody>
        <tbody v-else>
          <tr class="small">
            <td>Name:</td>
            <td>{{ order.firstname }} {{ order.lastname }}</td>
            <td>Order Date:</td>
            <td>{{ order.orderdate.substring(0, 10) }}</td>
          </tr>

          <tr class="small">
            <td>Username:</td>
            <td>{{ order.username }}</td>
            <td>Master Status:</td>
            <td>{{ order.masterstatus }}</td>
          </tr>

          <tr class="small">
            <td>Company:</td>
            <td>
              {{ order.clientid }}
              <router-link v-if="order.clientid" :to="{ name: '' }"
                ><span @click="supplierNotes(order)">
                  [Notes]</span
                ></router-link
              >
            </td>
            <td>Status code:</td>
            <td>{{ order.status }}</td>
          </tr>

          <tr class="small">
            <td>Product:</td>
            <td width="45%">{{ order.productname }}</td>
            <td>Supplier:</td>
            <td>
              <router-link
                :to="{
                  name: 'EditSupplier',
                  params: { Id: order.supplierid },
                }"
                ><span>{{ order.suppliername }} </span></router-link
              >
              <router-link v-if="order.suppliername" :to="{ name: '' }"
                ><span @click="supplierNotes(order)">[Notes]</span></router-link
              >
            </td>
          </tr>

          <tr class="small">
            <td>Gift:</td>
            <td>{{ order.gift === "true" ? "Yes" : "No" }}</td>
            <td>Billing Code:</td>
            <td>{{ order.billingcode }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="d-flex justify-content-between">
      <div>
        <span v-if="!allCustomerOrders.Result || allCustomerOrders.message"
          >Showing 0 to 0 of 0 entries</span
        >
        <span v-else
          >Showing {{ (currentPage - 1) * allCustomerOrders.pageSize + 1 }} to
          {{
            (currentPage - 1) * allCustomerOrders.pageSize +
              allCustomerOrders.selectedRecordCount
          }}
          of {{ allCustomerOrders.totalRecords }} entries</span
        >
      </div>
      <div class="" v-if="allCustomerOrders.Result">
        <pagination
          :data="allCustomerOrders.Result"
          :totalPages="Math.ceil(allCustomerOrders.totalRecords / perPage)"
          :total="allCustomerOrders.totalRecords"
          :perPage="perPage"
          :currentPage="currentPage"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination.vue";
export default {
  name: "CustomerOrdersResult",
  components: {
    pagination: Pagination,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      loading: false,
      newTitle: "",
    };
  },
  methods: {
    onPageChange(page) {
      console.log(this.$route.params.form);
      this.currentPage = page;
      this.loading = true;
      this.$store
        .dispatch("customerOrders/fetchCustomerOrders", {
          ...this.$store.state.customerOrders.form,
          pageNumber: this.currentPage,
          pageSize: this.perPage,
        })
        .then(() => {
          const el = document.getElementById("orders-list");
          el.scrollIntoView({ behavior: "smooth" });
        })
        .then(() => {
          this.loading = false;
        });
    },
    orderNotes(order) {
      this.$store.state.orderDetails.new_note = true;
      this.$store.dispatch("orderDetails/getOrder", {
        orderNumber: order.ordernumber,
      });
      this.$store
        .dispatch("orderDetails/getExtraOrderInfo", {
          orderId: order.orderid,
        })
        .then(() => {
          this.$router.push({
            name: "NotesManager",
            query: {
              order_id: order.orderid,
              note_id: -1,
            },
          });
        });
    },
    supplierNotes(order) {
      this.$store.state.orderDetails.new_note = true;
      this.$store.dispatch("orderDetails/getOrder", {
        orderNumber: order.ordernumber,
      });
      this.$store
        .dispatch("orderDetails/getExtraOrderInfo", {
          orderId: order.orderid,
        })
        .then(() => {
          this.$router.push({
            name: "NotesManager",
            query: {
              order_id: order.orderid,
              note_id: -1,
            },
          });
        });
    },
    clientNotes(order) {
      this.$store.state.orderDetails.new_note = true;
      this.$store.dispatch("orderDetails/getOrder", {
        orderNumber: order.ordernumber,
      });
      this.$store
        .dispatch("orderDetails/getExtraOrderInfo", {
          orderId: order.orderid,
        })
        .then(() => {
          this.$router.push({
            name: "NotesManager",
            query: {
              order_id: order.orderid,
              note_id: -1,
            },
          });
        });
    },
    saveSearch() {
      let payload = {
        title: this.newTitle,
        form_packet: {
          version: "1.0",
          header: "",
          data: {
            struct: {
              var: [
                {
                  key: "ExportOptions",
                  value: "",
                },
                {
                  key: "SBEGINDATE",
                  value: "",
                },
                {
                  key: "SEARCHFORM",
                  value: "true",
                },
                {
                  key: "SDAYSBACK",
                  value: "0",
                },
                {
                  key: "searchTitle",
                  value: "",
                },
                {
                  key: "RTNRECORDAMT",
                  value: "500",
                },
                {
                  key: "setMasterStatus",
                  value: "",
                },
                {
                  key: "SGIFT",
                  value: "0",
                },
                {
                  key: "setInvoiceNum",
                  value: "",
                },
                {
                  key: "invoiceNum",
                  value: "",
                },
                {
                  key: "INCLUDEORDER",
                  value: "1",
                },
                {
                  key: "setDateProc",
                  value: "",
                },
                {
                  key: "SSTATUSCODE",
                  value: "",
                },
                {
                  key: "SBATCHNUM",
                  value: "",
                },
                {
                  key: "SSUPPLIER",
                  value: "255",
                },
                {
                  key: "SENDDATE",
                  value: "",
                },
                {
                  key: "dateHandled",
                  value: "",
                },
                {
                  key: "GETBATCH",
                  value: "View batch",
                },
                {
                  key: "SINVOICENUM",
                  value: "",
                },
                {
                  key: "batchlabel",
                  value: "",
                },
                {
                  key: "SDATETYPE",
                  value: "1",
                },
                {
                  key: "FIELDNAMES",
                  value:
                    "SMASTERSTATUS,SSTATUSCODE,SDAYSBACK,SBATCHNUM,SBEGINDATE,SENDDATE,SDATETYPE,SORDERNUM,SINVOICENUM,SBILLINGCODE,SSUPPLIER,SCOMPANY,GETBATCH,SRCH_ID,SEARCHFORM",
                },
                {
                  key: "SORDERNUM",
                  value: "",
                },
                {
                  key: "SBILLINGCODE",
                  value: "",
                },
                {
                  key: "SMASTERSTATUS",
                  value: "P",
                },
                {
                  key: "SCOMPANY",
                  value: "0",
                },
                {
                  key: "SRCH_ID",
                  value: "",
                },
                {
                  key: "SETBATCHNUMBER",
                  value: "0",
                },
              ],
            },
          },
        },
      };

      this.newTitle = "";
      this.$store.dispatch("customerOrders/saveSearch", payload).then(() => {
        this.$store.dispatch("customerOrders/fetchSavedSearches");
      });
    },
  },
  computed: {
    allCustomerOrders() {
      return this.$store.getters["customerOrders/allCustomerOrders"];
    },
  },
  destroyed() {
    console.log("triggered");
    if (
      this.$route.name !== "OrderDetails" &&
      this.$route.name !== "CustomerOrders" &&
      this.$route.name !== "CustomerOrdersResult"
    ) {
      this.$store.state.customerOrders.customerOrders = null;
      this.$store.state.customerOrders.form = {
        startdate: "",
        billingcode: "",
        clientids: [],
        enddate: "",
        firstname: "",
        invoicenumber: "",
        isgift: false,
        lastname: "",
        ordernumbers: [],
        orderstatuscodes: [],
        supplierids: [],
        statuscodes: [],
        trackingnumber: "",
        username: "",
        userorderid: null,
        platform: "",
        pageNumber: 1,
        pageSize: 10,
        sortField: "ORDERDATE",
        sortOrder: "DESC",
        searchlimit: "50",
      };
      this.$store.state.customerOrders.filters = {
        list: "",
        islist: false,
        sDate: "",
        eDate: "",
      };
    }
  },
};
</script>
<style lang="scss" scoped>
.icon-span {
  font-size: 1.2rem;
}

.icon-list {
  cursor: pointer;
  color: #23363c;
}

.small {
  font-size: 0.8rem;
}

th,
td {
  padding: 10px !important;
}

tr:nth-child(even) {
  background-color: #f2f2f2 !important;
}

form {
  padding: 25px;
  border-radius: 5px;
  background-color: #f2f2f2;
}

.centered {
  position: fixed;
  top: 62%;
  left: 62%;
  transform: translate(-50%, -50%);
  transform: -webkit-translate(-50%, -50%);
  transform: -moz-translate(-50%, -50%);
  transform: -ms-translate(-50%, -50%);
  color: darkred;
}

.table-active {
  opacity: 0.5;
}
</style>
